<template>
    <div class="" style="width: 100%">
        <div class="checkbox-row mb-4">
            <v-checkbox
                v-model="checked"
                label="Manuelle Eingabe"
                color="#33bbff"
                value="0"
                hide-details
            ></v-checkbox>
        </div>

        <div v-if="!checked">
            <v-autocomplete
                v-model="objective"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                multiple
                cache-items
                item-text="name"
                item-value="id"
                hide-no-data
                no-filter
                hide-details
                label="Tippen Sie etwas, z.B. 'Wissen erweitern' oder 'Teambuilding'"
            ></v-autocomplete>
        </div>

        <div v-if="checked">
            <textarea class="input-text text-area" v-model="objective" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            checked: false,
            objective: [],

            loading: false,
            items: [],
            search: null,
        };
    },
    watch: {
        search(val) {
            val && this.querySelections(val);
        },
        objective() {
            this.$emit('input', this.objective);
        },
        checked() {
            if(this.checked) {
                this.selectedObjectives = [];
                this.objective = [];
            } else {
                this.objective = "";
            }
        }
    },
    methods: {
        querySelections(v) {
            this.loading = true;

            axios
                .post("/getObjectives", { search: v })
                .then(res => {
                    this.items = res.data.objs;
                    this.loading = false;
                    console.log(res, this.items);
                })
                .catch(error => {});
        }
    },
};
</script>
